<template>
  <div class="container" id="goods-edit">
    <!-- 面包屑导航 -->
    <div class="breadcrumb">
      <el-breadcrumb separator="">
        <el-breadcrumb-item>
          <div class="div1">矩阵管理</div>
        </el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/goodsList' }">
          <div class="div2">佣金管理</div>
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <!-- 面包屑导航 -->
    <!-- 查询 -->
    <div class="content page-title">
      <h2>平台佣金</h2>
      <div class="line"></div>
      <div style="display: flex; padding-top: 24px; padding-bottom: 24px">
        <div v-for="(item, index) in prices" :key="index" class="item-t">
          <div class="title">{{ item.title }}</div>
          <div class="price">{{ item.price }}</div>
        </div>
      </div>
      <!-- <bond
        :hadRechargeAmount="hadRechargeAmount"
        :awaitEarnestMoney="awaitEarnestMoney"
        :activeEarnestMoney="activeEarnestMoney"
      ></bond> -->
    </div>
    <div class="content">
      <h3>数据筛选</h3>
      <div>
        <el-form
          :inline="true"
          :model="searchForm"
          ref="searchForm"
          size="small"
        >
          <el-form-item label="下单用户" prop="userInfo">
            <el-input
              v-model="searchForm.userInfo"
              placeholder="请输入下单用户信息"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="订单编号" prop="orderNo">
            <el-input
              v-model="searchForm.orderNo"
              placeholder="请输入订单编号"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="订单时间" prop="brandId">
            <el-date-picker
              style="width: 250px"
              v-model="orderTime"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :default-time="['00:00:00', '23:59:59']"
              value-format="yyyy-MM-dd HH:mm:ss"
            >
            </el-date-picker>
          </el-form-item>

          <!-- <el-form-item label="类型" prop="type">
            <el-select
              v-model="searchForm.type"
              placeholder="请选择类型"
              filterable
              clearable
            >
              <el-option
                v-for="item in types"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item label="状态" prop="settlementStatus">
            <el-select
              v-model="searchForm.settlementStatus"
              placeholder="请选择状态"
              filterable
              clearable
            >
              <el-option label="未到账" value="1"></el-option>
              <el-option label="已到账" value="2"></el-option>
              <!-- <el-option
                v-for="item in dictionaries.platform_earnest_status"
                :key="item.dictId"
                :label="item.dictName"
                :value="item.dictId"
              >
              </el-option> -->
            </el-select>
          </el-form-item>
          <el-form-item>
            <div style="display: flex; margin-top: 4px">
              <div class="btn-search" @click="fetchData('search')">查询</div>
              <div
                class="btn-search"
                style="margin-left: 20px"
                @click="fetchData('reset')"
              >
                重置
              </div>
            </div>
            <!-- <el-button type="primary" @click="fetchData('search')"
              >查询</el-button
            >
            <el-button type="primary" plain @click="fetchData('reset')"
              >重置</el-button
            > -->
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="content">
      <div class="title">
        <h3>列表数据</h3>
        <div class="derive" @click="deriveDeliver">导出</div>
        <!-- <div>
          <el-button type="primary" @click="toFreeze">冻结金额</el-button>
          <el-button type="primary" @click="deriveDeliver">导出</el-button>
        </div> -->
      </div>
      <div id="base-list">
        <lb-table
          v-horizontal-scroll="'always'"
          :column="columns"
          :data="page.list"
          pagination
          :total="page.totalNum"
          layout="total, sizes, prev, pager, next, jumper"
          :page-sizes="[5, 10, 20, 30, 50]"
          :current-page.sync="page.currentPage"
          :page-size="page.pageSize"
          @selection-change="onMultipleSelection"
          @size-change="handleSizeChange"
          @p-current-change="handleCurrentChange"
        >
        </lb-table>
      </div>
    </div>
  </div>
</template>

<script>
import bond from '../components/bondData.vue'
import LbTable from '../../../components/lb-table/lb-table'
export default {
  components: {
    bond,
    LbTable
  },
  data () {
    return {
      orderTime: [],
      currentIndex: 0,
      name: '---',
      dialogUser: false,
      prices: [
        {
          title: '佣金总数',
          price: '0.00'
        },
        {
          title: '待结算佣金',
          price: '0.00'
        },
        {
          title: '已提现佣金',
          price: '0.00'
        },
        {
          title: '剩余佣金',
          price: '0.00'
        },
      ],
      tableData: [
        {}, {}, {}
      ],
      btns: ['个人信息', '订单信息', '地址信息', '银行卡信息', '佣金记录', '收藏记录', '粉丝记录', '提现记录'],
      types: [
        {
          id: '1',
          name: '充值'
        },
        // {
        //   id: '2',
        //   name: '提现'
        // },
        {
          id: '3',
          name: '冻结'
        },
      ],
      searchForm: {
        pageNo: 1,
        pageSize: 10,
        platformId: '',
        orderTimeStart: '',
        orderTimeEnd: '',
        userInfo: '',
        orderNo: '',
        settlementStatus: '',
      },
      list: [
        {
          name: '天兰',
          image: 'https://fenxiao.muruji.com/internalSystem/3e45d792-e3d5-4823-99c9-7919ff1c7fd8'
        },
        {
          image: 'https://fenxiao.muruji.com/internalSystem/3e45d792-e3d5-4823-99c9-7919ff1c7fd8'
        },
        {
          image: 'https://fenxiao.muruji.com/internalSystem/3e45d792-e3d5-4823-99c9-7919ff1c7fd8'
        }
      ],
      columns: [
        { type: 'selection', minWidth: '80', fixed: 'left' },
        {
          label: '下单用户', prop: 'orderUsername', minWidth: '120',
          render: (h, scope) => {
            return (
              <div style="text-align:center">
                <div style="text-align:left">{scope.row.orderUsername}</div>
                <div style="text-align:left">{scope.row.orderUserPhone}</div>
              </div>
            )
          }
        },
        { label: '订单编号', prop: 'orderNo', minWidth: '240' },
        {
          label: '商品信息',
          minWidth: '200',
          render: (h, scope) => {
            if (!scope.row.goodsInfoList) return
            return (
              <div style="text-align:left">
                {
                  scope.row.goodsInfoList.map(item => {
                    return (
                      <p>{item.goodsName + '-' + item.goodsSkuName + '*' + item.quantity}</p>
                    )
                  })
                }
              </div>
            )
          }
        },
        { label: '订单日期', prop: 'orderTime', width: '180' },
        { label: '订单金额', prop: 'orderAmount', width: '140' },
        { label: '优惠券金额', prop: 'discountAmount', width: '140' },
        { label: '平台佣金', prop: 'platformCommission', width: '140' },
        { label: '平台利润', prop: 'platformProfit', width: '140' },
        { label: '用户佣金', prop: 'userCommission', width: '140' },
        { label: '扣除保证金', prop: 'earnestMoney', width: '140' },
        { label: '实际佣金', prop: 'actualCommission', width: '140' },
        {
          label: '状态', prop: 'settleStatusLabel', minWidth: '100',
          render: (h, scope) => {
            let vv = ''
            if (scope.row.settleStatusLabel == '已到账') {
              vv = <p style="color:#666666;font-size:14px;display:flex"><div style="width: 10px;height: 10px;background: #12AB62;border-radius: 50%;opacity: 1;margin-top:7px;margin-right:4px;margin-left:10px"></div>
                <div>{scope.row.settleStatusLabel}</div>
              </p>
            } else {
              vv = <p style="color:#666666;font-size:14px;display:flex"><div style="width: 10px;height: 10px;background: #FF9226;border-radius: 50%;opacity: 1;margin-top:7px;margin-right:4px;margin-left:10px"></div>
                <div>{scope.row.settleStatusLabel}</div>
              </p>
            }

            return (
              <div> {vv}</div>
            )

          }
        },
        { label: '到账时间', prop: 'settleTime', minWidth: '240', },
      ],
      page: { list: [], pageNo: 1, pageSize: 10, totalNum: 0, currentPage: 1, status: '' },
      withdrawCommission: '',
      paidCommission: '',
      waitCommission: '',
      totalCommission: '',
      dictionaries: {},
    }
  },
  created () {
    this.getPlatformStatistics()
    // this.getDictionaries('platform_earnest_status')
    this.fetchData()
  },
  methods: {
    //导出
    deriveDeliver () {
      if (this.orderTime) {
        this.searchForm.orderTimeStart = this.orderTime[0]
        this.searchForm.orderTimeEnd = this.orderTime[1]
      }
      this.$api.exportCommissionOrderListA(this.searchForm).then(res => {
        if (res.code == 0) {
          this.downloadlink(res.data)
          this.$message({
            type: 'success',
            message: '导出成功!'
          })
        }
      })
    },
    downloadlink (url) {
      const iframe = document.createElement('iframe')
      iframe.style.display = 'none'
      iframe.src = url
      document.body.appendChild(iframe)
    },
    fetchData (type) {
      this.searchForm.platformId = this.$route.query.platformId
      if (this.orderTime) {
        this.searchForm.orderTimeStart = this.orderTime[0]
        this.searchForm.orderTimeEnd = this.orderTime[1]
      }

      if (type == 'reset') {
        this.searchForm = {}
        this.orderTime = []
        this.searchForm.platformId = this.$route.query.platformId
        this.searchForm.pageNo = 1
        this.searchForm.pageSize = 10
      }
      this.$api.getCommissionOrderListA(this.searchForm).then(res => {
        if (res.code == 0) {
          res.data.list.forEach(item => {
            if (item.settleTime) {
              item.settleTime = item.settleTime
            } else {
              item.settleTime = '--'
            }
          })
          this.page.list = res.data.list
          this.page.totalNum = res.data.totalNum
          this.loading = false
        }
      })
    },
    getPlatformStatistics () {
      let params = {
        platformId: this.$route.query.platformId
      }
      this.$api.getCommissionPlatformData(params).then(res => {
        if (res.code == 0) {
          this.prices[0].price = res.data.totalCommission
          this.prices[1].price = res.data.awaitCommission
          this.prices[2].price = res.data.paidCommission
          this.prices[3].price = res.data.activeCommission
        }
      })
    },
    // 获取字典数据
    getDictionaries (type) {
      const params = { groupId: type }
      this.$api.dictionaries(params).then((res) => {
        this.dictionaries['platform_earnest_status'] = res.data
      }).catch((err) => {
        console.log(err)
      })
    },
    onMultipleSelection (val) {
      this.selectionGoods = val
    },
    handleCurrentChange (currentChange) {
      this.page.pageNo = currentChange
      this.searchForm.pageNo = currentChange
      this.fetchData()
    },
    handleSizeChange (sizeChange) {
      this.page.pageSize = sizeChange
      this.searchForm.sizeChange = sizeChange
      this.fetchData()
    },
    clickbtn (index) {
      this.currentIndex = index
    },
    toFreeze () {
      this.$router.push({
        name: 'freezeMoney',
        query: {
          id: this.$route.query.id
        }
      })
    }
  }
}
</script>
<style scoped lang="scss">
.btn-search {
  width: 68px;
  height: 32px;
  background: #e3edff;
  opacity: 1;
  border-radius: 4px;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 32px;
  color: #4168e7;
  text-align: center;
  cursor: pointer;
}
.derive {
  width: 120px;
  height: 36px;
  background: #4168e7;
  opacity: 1;
  border-radius: 4px;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 36px;
  color: white;
  text-align: center;
  cursor: pointer;
}
.line {
  width: 1648px;
  height: 0px;
  border: 1px solid #ededed;
  opacity: 1;
}
.item-t {
  width: 270px;
  height: 88px;
  background: #f2f5ff;
  opacity: 1;
  border-radius: 4px;
  margin-right: 18px;
  .title {
    // width: 56px;
    height: 20px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: bold;
    line-height: 20px;
    color: #333333;
    opacity: 1;
    margin-left: 20px;
    margin-top: 18px;
  }
  .price {
    // width: 103px;
    height: 25px;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: bold;
    line-height: 25px;
    color: #4168e7;
    opacity: 1;
    margin-left: 20px;
    margin-top: 8px;
  }
}
.div1 {
  margin-left: -16px;
  background: url(../../../assets/breadcrumb2.png);
  width: 120px;
  height: 30px;
  text-align: center;
  line-height: 30px;
  color: #2d7edf;
}

.div2 {
  margin-left: -16px;
  background: url(../../../assets/breadcrumb1.png);
  width: 120px;
  height: 30px;
  text-align: center;
  line-height: 30px;
  color: #fff;
}
.dialog-search {
  display: flex;
  width: 46%;
  justify-content: space-between;
  margin-top: 10px;
  margin-left: 10px;
}
.title {
  display: flex;
  justify-content: space-between;
}
#base-list {
  margin-top: 20px;
  padding-bottom: 20px;
}
:deep(
    #base-list
      .lb-table
      .el-table
      .el-table__body
      .el-table__row
      .el-table__cell:last-child
      .cell
      div
  ) {
  display: inline-block;
  /* a {
    margin: 0 5px;
  } */
}
</style>
